module.exports = fox._r("images/slides/slide_3_1.jpg", __webpack_public_path__ + "images/slides/slide_3_1.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/slide_3_1.jpg
// module id = 516
// module chunks = 2